import React, { useCallback, useEffect, useState } from 'react'
import Dashbard from '../Dashbard';
import Loader from '../../../../components/common/Loader';
import { Accordion, AccordionSummary, Button, FormControl, Grid, IconButton, TextField, Typography } from '@material-ui/core';
import AddIcon from "@material-ui/icons/Add";
import GridSearchFilter, { SelectedDateChip } from '../../../../components/common/FilterLayout/GridFilter';
import PastCompaignsGrid from './PastCompaignsGrid';
import { useDebounce } from '../../../../utils/use-debounce';
import { MarketingModal } from './MarketingModal';
import { launchesActions } from '../../../../store/launches/launchesActions';
import { useDispatch } from 'react-redux';
import { ExpandMore, MoreHoriz } from '@material-ui/icons';
import { FilterCreationDate } from '../EndUser';
import { ChipItem } from '../Conversations/ConverstionSettings/GridFilter';
import { InputField, Pagination } from '../../../../components/common';
import { CampaignsPreviewModal } from './CampaignsPreviewModal';
import { DeleteFilesOverlay } from '../../../../components/common/Modal/AssetsModals';
import { toast } from 'react-toastify';
import { Autocomplete } from '@material-ui/lab';

const campaignTypes = [
  "Email",
];

const groupTypes = [
  { label: "Business Customers", value: "BusinessCustomer" },
  { label: "End Customers", value: "EndCustomer" },
  { label: "Leads", value: "Leads" },
];

const PastCampaigns = () => {
    const dispatch = useDispatch();
    let filtersIndex = 0;
    const filtersLimit = 4;
    const [isLoading , setLoading] = useState(false);
    const [openCampaignModal , setOpenCampaignModal] = useState(false);
    const [openCampPreviewModal , setOpenCampPreviewModal] = useState(null);
    const [campaignsData ,setCampaignsData] = useState([]);
    const [openDeleteFilesOverlay , setOpenDeleteFilesOverlay] = useState(null);
    const [filters, setFilters] = useState({
      name: "",
      body: "",
      groupType: "",
      dateFrom: null,
      dateTo: null,
      type: "",
    });
    const [paginationResponse, setPaginationResponse] = useState({
      currentCount: 0,
      totalRecords: 0,
    });
      const { debouncedValue } = useDebounce(filters.name , 500)
      const [isFilter, setIsFilter] = useState(false);
      const [showFilterCounter, setShowFilterCounter] = useState(0);
      const [showFilters, setShowFilter] = useState(false);
      const [page, setPage] = useState(1);
      const [rowsPerPage, setRowsPerPage] = useState(10);
      const [order, setOrderBy] = useState({
        key: "Id",
        val: 0,
      });
      const [isMailResend , setIsMailResend] = useState(null);
      const filtersCount =
      (filters.body ? 1 : 0) +
      (filters.type ? 1 : 0) +
      (filters.groupType ? 1 : 0) +
      (filters.dateFrom ? 1 : 0) +
      (filters.dateTo ? 1 : 0);

      const loadAllCampaigns = useCallback(() => {
        setLoading(true);
        const modal = {
          subject: debouncedValue,
          body: filters.body,
          groupType: filters.groupType,
          dateFrom: filters.dateFrom ?? "",
          dateTo: filters.dateTo ?? "",
          type: filters.type,
          pagination: {
            pageSize: rowsPerPage,
            pageNo: page,
            orderByKey: order.key,
            orderByVal: order.val,
          }};
        dispatch(launchesActions.onGetAllCampaigns(modal)).then(data => {
          if (data?.success) {
            if (data?.data) {
              setCampaignsData(data?.data?.data)
              if(data?.data?.pagination){
                setPaginationResponse(data?.data?.pagination)
              }else{
                setPaginationResponse({
                  currentCount: 0,
                  totalRecords: 0,
                })
              }
            }
          }
          setLoading(false);
        });
      }, [
        dispatch,
        page,
        rowsPerPage,
        order.key,
        order.val,
        debouncedValue,
      ]);
    
      useEffect(() => {
        loadAllCampaigns();
      }, [
        page,
        rowsPerPage,
        debouncedValue,
        order,
      ]);

      const showFilter = () => {
        window.scroll(0, 0);
        // document.body.classList.add("bodyScroll");
        setIsFilter(true);
      };

      const hideFilter = () => {
        setIsFilter(false);
      };

      const applyFilters = () => {
        setLoading(true);
        setShowFilterCounter(filtersCount);
        hideFilter();
        dispatch(launchesActions.onGetAllCampaigns({
          subject: debouncedValue,
          body: filters.body,
          groupType: filters.groupType,
          dateFrom: filters.dateFrom ?? "",
          dateTo: filters.dateTo ?? "",
          type: filters.type,
          pagination: {
            pageSize: rowsPerPage,
            pageNo: page,
            orderByKey: order.key,
            orderByVal: order.val,
          }})).then(data => {
          if (data?.success) {
            if (data?.data) {
              setCampaignsData(data?.data?.data)
              setPaginationResponse(data?.data?.pagination)
            }
          }
          setLoading(false);
        })
      }

      const onClearButtonPress = () => {
        setLoading(true);
        setPage(1);
        setRowsPerPage(10);
        setShowFilterCounter(0);
        setFilters({
          subject: "",
          body: "",
          groupType: "",
          type: "",
          dateFrom: null,
          dateTo: null,
        });
        dispatch(launchesActions.onGetAllCampaigns({
          subject: "",
          body: "",
          groupType: "",
          dateFrom:  "",
          dateTo: "",
          type: "",
          pagination: {
            pageSize: rowsPerPage,
            pageNo: page,
            orderByKey: order.key,
            orderByVal: order.val,
          }})).then(data => {
            console.log({data })
          if (data?.success) {
            if (data?.data) {
              setCampaignsData(data?.data?.data)
              setPaginationResponse(data?.data?.pagination)
            }
          }
          setLoading(false);
        })
      };

      useEffect(()=>{
        dispatch(launchesActions.onGetAllLeads());
        dispatch(launchesActions.onGetAllEndCustomers());
        dispatch(launchesActions.onGetAllBusinessCustomers());
      },[]);

      const handleDeleteCampaign = ()=>{
        dispatch(launchesActions.onDeleteCampaignById(openDeleteFilesOverlay)).then((res)=>{
          if(res.success){
            toast.success("The Marketing Campaign Deleted Successfully")
            loadAllCampaigns()
            setOpenDeleteFilesOverlay(null);
          }else{
            toast.success("The marketing campaign was not deleted successfully.")
            setOpenDeleteFilesOverlay(null);
          }
        })
      }

      function extractIds(arr) {
        return arr.map(item => item.userId);
      }

      const onsubmitResendMail = ()=>{
        setLoading(true);
        dispatch(launchesActions.onResendMarketingCampaignMails({
            campaignId: isMailResend?.id,
            type: isMailResend?.type,
            businessUsers: extractIds(isMailResend?.businessUsers),
            campaignEndUsers: extractIds(isMailResend?.campaignEndUsers),
            campaignLeadUsers: extractIds(isMailResend?.campaignLeadUsers),
          })).then(data => {
          if (data?.success) {
            setIsMailResend(null);
            toast.success("Email successfully resent.")
          }else{
            toast.error("Error! The email(s) could not be resent. Please try again.")
          }
          setLoading(false);
        });
      }

  return (
    <Dashbard>
    <div className='body-content'>
      {isLoading ? <Loader /> : null}
      <div className='contentHeading launchBtn'>
        <h1>Marketing Campaigns</h1>
        <Button
          color='primary'
          variant='contained'
          startIcon={<AddIcon />}
          onClick={() => setOpenCampaignModal(true)}
          >
          New Campaign
        </Button>
      </div>

      <div className='gridBody contentBody '>
        <GridSearchFilter
          isFilterAdded={true}
          setFilters={setFilters}
          filters={filters}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          title={"Campaign Filter"}
          isFilter={isFilter}
          showFilter={showFilter}
          hideFilter={hideFilter}
          applyFilters={applyFilters}
          showFilterCounter={showFilterCounter}
        >
        <Accordion
          defaultExpanded
          id='end-user-filter-expandable'
          TransitionProps={{ unmountOnExit: true }}>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography>
              <span>Active Filter(s)</span>
              <span>
                <Button
                  className='filterClearBtn filterClearBtnStyle'
                  variant='outlined'
                  onClick={() => {
                    hideFilter();
                    onClearButtonPress();
                  }}>
                  Clear
                </Button>
              </span>
            </Typography>
          </AccordionSummary>
          <div style={{ marginBottom: "10px" }}>
            {filtersCount <= 0 && (
              <div className={`filtersChips`}>No Active Filter(s)</div>
            )}
          </div>

          <SelectedDateChip
            startDate={filters.dateFrom}
            endDate={filters.dateTo}
            setStartDate={date => {
              setFilters(prevFilters => ({
                ...prevFilters,
                dateFrom: date,
              }));
            }}
            setEndDate={date => {
              setFilters(prevFilters => ({
                ...prevFilters,
                dateTo: date,
              }));
            }}
            chipLabel={"Creation Date"}
          />
          {filters.body?.length > 0 &&
            (filtersIndex <= filtersLimit ||
              (filtersIndex > filtersLimit && showFilters)) && (
              <ChipItem
                chipLabel='Body'
                chipValue={filters.body}
                onDelete={() => {
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    body: "",
                  }));
                }}
              />
            )}
          {filters.groupType?.length > 0 &&
            (filtersIndex <= filtersLimit ||
              (filtersIndex > filtersLimit && showFilters)) && (
              <ChipItem
                chipLabel='Group Type'
                chipValue={filters.groupType}
                onDelete={() => {
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    groupType: "",
                  }));
                }}
              />
            )}

          {filters.type?.length > 0 &&
            (filtersIndex <= filtersLimit ||
              (filtersIndex > filtersLimit && showFilters)) && (
              <ChipItem
                chipLabel='Type'
                chipValue={filters.type}
                onDelete={() => {
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    type: "",
                  }));
                }}
              />
            )}

          <div
            style={{
              textAlign: "right",
            }}>
            {filtersCount > filtersLimit && (
              <IconButton
                color={"primary"}
                onClick={() => setShowFilter(!showFilters)}>
                <MoreHoriz />
              </IconButton>
            )}
          </div>
        </Accordion>
        <div className='userDetailsSearchField inputWrapper filterSelect'>
              <div style={{ marginBottom: "10px" }}>
                <h4>Campaign Creation Date</h4>
                <FilterCreationDate
                  StartDate={filters.dateFrom}
                  setStartDate={date => {
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      dateFrom: date,
                    }));
                  }}
                  EndDate={filters.dateTo}
                  setEndDate={date => {
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      dateTo: date,
                    }));
                  }}
                />
              </div>
              {/* <InputField
                id='body'
                name='body'
                placeholder={"Body"}
                value={filters.body}
                onChange={({ target }) =>
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    body: target.value,
                  }))
                }
              /> */}
              {/* <InputField
                id='groupType'
                name='groupType'
                placeholder={"Group Type"}
                value={filters.groupType}
                onChange={({ target }) =>
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    groupType: target.value,
                  }))
                }
              /> */}
              <FormControl className='ac-dd'>
                <Autocomplete
                  // value={filters.type}
                  onChange={(event, value) => {
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      groupType: value.value,
                    }))
                  }}
                  multiple={false}
                  filterSelectedOptions
                  id='group-type-dd'
                  options={groupTypes}
                  getOptionLabel={option => option.label || ""}
                  renderInput={params => (
                    <TextField
                      {...params}
                      inputProps={{ ...params.inputProps, autoComplete: 'none' }}
                      placeholder={"Group Type"} />
                  )}
                />
            </FormControl>
               {/* <InputField
                id='type'
                name='type'
                placeholder={"Type"}
                value={filters.type}
                onChange={({ target }) =>
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    type: target.value,
                  }))
                }
              /> */}
              <FormControl className='ac-dd'>
                <Autocomplete
                  // value={filters.type}
                  onChange={(event, value) => {
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      type: value,
                    }))
                  }}
                  multiple={false}
                  filterSelectedOptions
                  id='campaign-type-dd'
                  options={campaignTypes}
                  getOptionLabel={option => option || ""}
                  renderInput={params => (
                    <TextField
                      {...params}
                      inputProps={{ ...params.inputProps, autoComplete: 'none' }}
                      placeholder={"Campaign Type"} />
                  )}
                />
            </FormControl>
        </div>
        </GridSearchFilter>
          <Grid container justifyContent='flex-end'>
            <span className='gridTopPagination'>
              <Pagination
                recordCount={paginationResponse?.totalRecords}
                page={page - 1}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                rowsPerPageOptions={[]}
                backIconButtonProps={{ style: { display: "none" } }}
                nextIconButtonProps={{ style: { display: "none" } }}
              />
            </span>
          </Grid>
        <PastCompaignsGrid
          campaignsData={campaignsData}
          order={order}
          onOrderBy={setOrderBy}
          setOpenCampPreviewModal={(v)=>setOpenCampPreviewModal(v)}
          setOpenDeleteFilesOverlay={setOpenDeleteFilesOverlay}
          isMailResend={isMailResend}
          setIsMailResend={setIsMailResend}
        />
        <Pagination
          recordCount={paginationResponse?.totalRecords}
          page={page - 1}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        />
      </div>
    </div>
    {
        openCampaignModal ?      
      
          <MarketingModal
         open={openCampaignModal}
         setOpen={(v)=>{
           setOpenCampaignModal(v);
         }}
         setLoading={setLoading}
         loadAllCampaigns={loadAllCampaigns}
        />     
        : null
    }
    {
      openCampPreviewModal ? 
      <CampaignsPreviewModal
       open={openCampPreviewModal}
       setOpen={(v)=>{
        setOpenCampPreviewModal(v);
       }}
      /> : null
    }
    {
      openDeleteFilesOverlay ?
      <div className='campaignDeleteOverlay'>
      <DeleteFilesOverlay
      openDeleteFilesOverlay={openDeleteFilesOverlay}
      setOpenDeleteFilesOverlay={setOpenDeleteFilesOverlay}
      deleteAssetFiles={handleDeleteCampaign}
      overlayText1={"Are you sure you want to Delete Marketing Campaign?"}
      overlayText2={""}
      buttonText={"Delete"}
      heading="Delete Marketing Campaign"
      />
      </div> : null
    }
    {
      isMailResend ?
        <div className='campaignDeleteOverlay'>
          <DeleteFilesOverlay
            openDeleteFilesOverlay={isMailResend}
            setOpenDeleteFilesOverlay={setIsMailResend}
            deleteAssetFiles={onsubmitResendMail}
            overlayText1={"Are you sure you want to resend email(s)?"}
            overlayText2={""}
            buttonText={"Resend"}
            heading="Resend Email(s)"
            isDeleteButton={false}
          />
        </div> : null
    }
  </Dashbard>
  )
}

export default PastCampaigns;